

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './TermsPage.css';
import TopBar from '../TopBar';
import Footer from '../Footer';


function TermsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  let showActions=true;
  // Read hideActions from URL params
  const params = new URLSearchParams(location.search);
  const hideActionsFromFooter = params.get('accepted') === 'true';
  
  if (hideActionsFromFooter) {
    sessionStorage.setItem('knorr-terms-accepted', 'true');
    showActions = false;
  }

  // const handleAccept = () => {
  //   sessionStorage.setItem('knorr-terms-accepted', 'true');
  //   navigate('/');
  // };

  // if (sessionStorage.getItem('knorr-terms-accepted')) {
  //    showActions = false;
  // }

  // const handleDecline = () => {
  //   sessionStorage.removeItem('knorr-terms-accepted');
  //   navigate('/thank-you');
  // };

  return (
    <div>
        <TopBar />
        <div className="terms-container">
      <div className="terms-content">
        <h1 className="terms-title">Terms &amp; Conditions</h1>
        {/* ...existing sections... */}
        <section>
          <h2>1. Introduction</h2>
          <p>
           Welcome to the Knorr Ramadan 2026 GenAI Recipe Tool (“Knorr Recipe AI”). This Tool helps you discover new dinner recipes based on the ingredients you have at home. By using this Tool, you agree to the following Terms of Use. This Tool is intended <b>solely for use by individuals aged 18 years and above</b>. By using the Knorr GenAI Recipe Tool, you confirm that you are at least 18 years old.
          </p>
          <p>
            This Tool is powered by an AI system using a large language model trained by <b>GeminiAI</b>, operated in accordance with <b>Unilever’s Responsible AI Principles</b>, including transparency, accountability, fairness, and privacy
          </p>
        </section>
        <section>
          <h2>2. Privacy Notice &amp; Data Use</h2>
          <p>We respect your privacy and handle your information in line with Unilever’s global data protection and responsible AI guidelines.</p>
          <h3>2.1 What Data We Collect</h3>
          <p>To generate recipes tailored to your kitchen inputs, the Tool may collect:</p>
          <ul>
            <li>Images or videos of your pantry or fridge (if you choose to upload them).</li>
            <li>Manually typed or selected ingredient lists.</li>
            <li>Basic, non-personal usage data (e.g., session activity, clicks).</li>
          </ul>
          <h3>2.2 How Your Data Is Used</h3>
          <p>Your ingredient data is used only to generate recipes during your current session.</p>
          <ul>
            <li>This data is <b>stored temporarily</b> and automatically deleted after the session ends.</li>
            <li>No personal identifiers are required or collected.</li>
            <li>Your data will <b>not</b> be used to train AI models, shared with third parties for marketing, or retained for profiling purposes, in alignment with Unilever’s Responsible AI and Privacy principles.</li>
          </ul>
          <h3>2.3 Your Choices</h3>
          <ul>
            <li>You are not obligated to upload images or videos—manual typing is available.</li>
            <li>You may stop using the Tool at any time, after which your session data is deleted.</li>
          </ul>
        </section>
        <section>
          <h2>3. AI-Generated Recipe Disclaimer (Brand Safety &amp; Accuracy)</h2>
          <p>This Tool uses Generative AI to produce recipe suggestions.</p>
          <ul>
            <li>Recipes are generated <b>automatically</b> and may sometimes contain inaccuracies or unexpected combinations.</li>
            <li>While we apply brand safety guardrails based on Unilever’s internal AI guidance, results may not always be perfect.</li>
            <li>You are responsible for ensuring ingredients are safe, allergen-checked, and properly cooked.</li>
          </ul>
          <p><b>Knorr and Unilever do not guarantee the nutritional accuracy, completeness, or suitability of any AI-generated recipe.</b></p>
        </section>
        <section>
          <h2>4. No Nutritional or Health Information</h2>
          <p>As agreed during initial development, the Tool <b>does not provide</b> nutritional guidance, calorie information, or health-specific recipe advice. This helps maintain a simple and user-friendly experience while we continue developing the platform.<br/>Please consult qualified nutrition or healthcare professionals for dietary guidance.</p>
        </section>
        <section>
          <h2>5. Acceptable Use</h2>
          <p>When using the Tool, you agree not to:</p>
          <ul>
            <li>Upload harmful, unlawful, offensive, or misleading content.</li>
            <li>Upload any personally identifiable information or human faces.</li>
            <li>Attempt to misuse or manipulate the AI system.</li>
            <li>Attempt to extract the underlying AI model or reverse-engineer the system.</li>
          </ul>
          <p>These restrictions align with Unilever’s internal <b>prohibited AI use cases.</b></p>
        </section>
        <section>
          <h2>6. Intellectual Property</h2>
          <ul>
            <li>The AI-generated recipes are provided for your personal, non-commercial use.</li>
            <li>Any Knorr trademarks, branding, and interface content remain owned by Unilever.</li>
            <li>You may share or use the generated recipes privately but may not use them to create commercial content without permission.</li>
          </ul>
        </section>
        <section>
          <h2>7. Liability</h2>
          <p>The Tool is provided “as-is” for convenience and inspiration.<br/>Unilever shall not be liable for:</p>
          <ul>
            <li>Any cooking mishaps, food-related outcomes, or allergic reactions;</li>
            <li>Errors or omissions in AI-generated outputs;</li>
            <li>Technical interruptions or outages.</li>
          </ul>
          <p>Your use of the Tool is at your own discretion and risk.</p>
        </section>
        <section>
          <h2>8. Updates to the Terms</h2>
          <p>We may update these Terms occasionally to reflect improvements, regulatory needs, or internal AI governance changes. Updates will be posted within the Tool interface.</p>
        </section>
        <section>
          <h2>9. Contact Us</h2>
          <p>If you have questions or concerns about privacy or the Tool, you may contact Unilever Consumer Services or consult Unilever’s Responsible AI materials available publicly.</p>
        </section>
        <section>
          <h2>10. Health &amp; Safety Disclaimer</h2>
          <p>The Knorr GenAI Recipe Tool provides recipe suggestions generated automatically by Artificial Intelligence. While we aim to provide helpful, creative, and culturally appropriate ideas for dinner:</p>
          <ul>
            <li><b>You remain fully responsible for ensuring safe food handling, preparation, and consumption.</b><br/>This includes washing produce, checking ingredient expiry dates, following safe cooking temperatures, and preventing cross-contamination.</li>
            <li><b>Always verify ingredient safety</b>—especially in relation to allergies, intolerances, or dietary sensitivities. The Tool does not detect allergens, dietary restrictions, or food hazards.</li>
            <li><b>The AI may occasionally generate combinations that require adjustment to ensure practicality and safety.</b> Please use your own judgment before preparing or consuming any dish.</li>
          </ul>
        </section>

        {/* {showActions && (<div className="terms-buttons">
          <button className="terms-button-accept" onClick={handleAccept}>Accept &amp; Continue</button>
          <button className="terms-button-decline" onClick={handleDecline}>Decline</button>
        </div>)} */}
        
      </div>
    </div>
    <Footer />
    </div>
    
  );
}

export default TermsPage;
